import { render, staticRenderFns } from "./updateProductRetailerMargin.vue?vue&type=template&id=1db278a0"
import script from "./updateProductRetailerMargin.vue?vue&type=script&lang=js"
export * from "./updateProductRetailerMargin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports